module.exports = __webpack_public_path__ + "static/6-00073a10033e55a5c07089ce8fea48ea.jpeg";